export default __webpack_public_path__ + "static/media/open-link-light.015935d1.svg";